import CustomHead from 'components/commons/CustomHead'
import Template from 'components/LP/LP202407/Thanks'
import useLocalStorage from 'hooks/useLocalStorage'

const Thanks: React.FC = () => {
  const fromCorrectFormPage = useLocalStorage('refGithubActionsLpContactPage')
  return (
    <>
      {fromCorrectFormPage ? (
        <CustomHead
          keyword={'GitHub Actions CI/CD パイプライン デプロイ ビルド'}
          image={'https://aitria.co.jp/img/ogp_logo.png'}
          url={'https://aitria.co.jp/services/githubactions/thanks/'}
          title="送信完了 Github Actions | サービス | Aitria（アイトリア）"
          description="GitHub Actions導入支援で、CI/CDパイプラインを自動化し、コードのビルド、テスト、デプロイを迅速化。開発からリリースまでのサイクルを大幅短縮します。"
        />
      ) : (
        <></>
      )}
      <Template />
    </>
  )
}

export default Thanks
